module.exports = __webpack_public_path__ + "img/img_c_not.bce436af.webp";